import React from "react";
import Svg from "../../../components/Svg/Svg";
import { SvgProps } from "../../../components/Svg/types";

interface LogoProps extends SvgProps {
  isDark: boolean;
}

const Logo: React.FC<LogoProps> = ({ isDark, ...props }) => {
  return (
    <>

    <img style={{ maxWidth: '80px'}} src="images/Swaps.png" />

  <b style={{ fontFamily: '"Lilita One", Sans-serif',fontWeight: 600,color:'#FFF', fontSize: '17px' }}>POLYSWAP </b>

  </>
  );
};

export default Logo;
